


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const fatburning: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "fat-burning-injections",
        "meta": {
            "title": "Fat Burning Injections in Dubai | Elite Body Home",
            "description": "Non-surgical fat reduction with fat dissolving injections that target stubborn fat in areas like chin, belly, thighs and more without dieting or exercise.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/fat-burning-injections/",
            "og": {
                "title": "Fat Burning Injections in Dubai | Elite Body Home",
                "description": "Non-invasive fat reduction treatment using specialized injections to dissolve stubborn fat deposits",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-51.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Fat Burning Injections"],
        "hero": {
            "title": "Fat Burning Injections in Dubai",
            "subtitle": "Non-Surgical Fat Reduction",
            "description": "Having persistent stubborn fat, no matter what you do, from dieting to exercising? Fat burning injections are the non-surgical way to reduce fat without demanding diets and hard physical exercises. From targeting your double chin to belly fat to your thighs and everything in between, these fat-dissolving injections can do wonders to sculpt and contour your body. We get it — these challenges at Elite Body Home. Our fat reduction treatments are performed with safe, sophisticated technology by skilled practitioners, so you can have a beautifully sculpted and contoured body with minimal downtime."
        },
        "howItWorks": {
            "title": "How Do Fat Burning Injections Work?",
            "description": "Fat Burning Injections are non-invasive treatments that enable localized fat deposits to get broken down and eliminated through the body. These injections usually consist of substances that expedite the breakdown of fat and enhance the body sculpting process."
        },
        "procedureSteps": {
            "heading": "Treatment Process",
            "para": "Here's what to expect during your Fat Burning Injections treatment:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "It starts with a consultation and the Body Composition Analysis (BCA) provides a thorough health assessment. Also for fat burning injections blood test can be required in some cases.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "Marking the Area",
                    "desc": "Areas are marked where the injections will be given. This is typically where the fat is most visible.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "Injection Process",
                    "desc": "Fat melting injections are given through very fine needles which causes minimum discomfort. Results can take time, several sessions are required based on the outcome.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Follow-Up",
                    "desc": "For your follow-up visits, we're making sure that you're headed toward your end goals, and making any changes to your treatment plan if necessary.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Fat Dissolving Injections",
            "subheading": "Targeted fat reduction without surgery",
            "para": "Fat burning injections offer multiple advantages for body contouring:",
            "items": [
                {
                    "title": "Melts Stubborn Fat",
                    "desc": "Melts away stubborn fat in targeted locations.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Non-Surgical",
                    "desc": "A non-surgical approach that defines the jawline and improves the appearance of the double chin.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Minimally Invasive",
                    "desc": "Treat as minimally invasive, outpatient, non-surgical procedure.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Rapid Results",
                    "desc": "Helps to melt the belly fat for rapid results.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "No Exercise Needed",
                    "desc": "Short workouts with low no-training time.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Natural Looking",
                    "desc": "Provides smooth, natural-looking results.",
                    "icon": "fa-solid fa-leaf"
                }
            ]
        },
        "eligibility": {
            "heading": "Ideal Candidates",
            "subheading": "",
            "para": "Fat melting injections are ideal for:",
            "items": [
                {
                    "title": "Near Ideal Weight",
                    "desc": "Are at or near their ideal weight with stubborn pockets of fat.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Targeted Areas",
                    "desc": "Want focused fat loss in the chin, belly and thighs.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "Non-Surgical Option",
                    "desc": "Those who are healthy and not surgical candidates.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "Set realistic expectations for slow and gradual, natural-looking results.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Hydrated Skin",
                    "desc": "Have well hydrated skin for easy contouring.",
                    "icon": "fa-solid fa-tint"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Treatment",
            "subheading": "",
            "para": "To prepare for your fat dissolving injections:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water before your treatment to support the fat elimination process.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Avoid medications that thin blood for a few days before treatment.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Healthy Diet",
                    "desc": "Maintain a balanced diet to support your body's natural detoxification.",
                    "icon": "fa-solid fa-apple-alt"
                },
                {
                    "title": "Wear Comfortable Clothes",
                    "desc": "Choose loose clothing that allows easy access to treatment areas.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "Fat dissolving injections provide progressive improvements:",
            "items": [
                {
                    "title": "Gradual Improvement",
                    "desc": "Results appear gradually over several weeks as the body processes the dissolved fat.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Multiple Sessions",
                    "desc": "Optimal results typically require 3-6 sessions spaced 4-6 weeks apart.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Permanent Fat Reduction",
                    "desc": "A permanent reduction in the number of fat cells in treatment areas.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Natural Contouring",
                    "desc": "For a sculpted look that boosts confidence.",
                    "icon": "fa-solid fa-user"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain your fat dissolving injection results:",
            "items": [
                {
                    "title": "Massage Treated Area",
                    "desc": "Gentle massage can help distribute the solution and improve results.",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "Stay Active",
                    "desc": "Light exercise helps your body metabolize the released fat.",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "Hydrate Well",
                    "desc": "Drink plenty of water to support your lymphatic system.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Follow Treatment Plan",
                    "desc": "Complete all recommended sessions for optimal outcomes.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Are fat burner injections safe?",
                    "answer": "Yes, fat burner injections are generally safe when performed by a qualified professional, ensuring proper technique and aftercare to minimize risks."
                },
                {
                    "question": "How long does a fat burning injection last?",
                    "answer": "The results of fat dissolving injections last a lifetime. The fat cells do not reoccur in the treated areas."
                },
                {
                    "question": "What is the best injection for fat loss?",
                    "answer": "The best fat loss injection depends on individual needs, with popular options including Aqualyx and Kybella, which target stubborn fat areas effectively."
                },
                {
                    "question": "Do fat dissolving injections really work?",
                    "answer": "Yes, fat-dissolving injections break down fat cells, which are then naturally eliminated by the body."
                },
                {
                    "question": "How many sessions will I need?",
                    "answer": "Most patients require 3-6 sessions spaced 4-6 weeks apart for optimal results."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fat-burning-header-1024x671.jpg",
            "beforeAfter": [
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Postnatal-Weight-Loss-4.webp",
                    alt: "fat reduction treatments",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/110.webp",
                    alt: "belly fat removal",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/109.webp",
                    alt: "fat dissolving injections",
                },
            ],
        },
        "product": {
            "id": 8,
            "title": "Fat Burning Injections in Dubai",
            "description": "Non-surgical fat reduction using specialized injections to dissolve stubborn fat in areas like chin, belly and thighs.",
            "price": 1200
        }
    },
    "ar": {
        "url": "fat-burning-injections",
        "meta": {
            "title": "إبر إذابة الدهون في دبي | ايليت بودي هوم",
            "description": "علاج غير جراحي لتقليل الدهون العنيدة في مناطق مثل الذقن، البطن، الفخذين وغيرها بدون أنظمة غذائية أو تمارين شاقة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/fat-burning-injections",
            "og": {
                "title": "إبر إذابة الدهون في دبي | ايليت بودي هوم",
                "description": "علاج غير جراحي لتقليل الدهون باستخدام إبر متخصصة لإذابة الدهون العنيدة",
                "image": "https://www.elitebodyhome.com/images/fat-burning-injections-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إبر إذابة الدهون"],
        "hero": {
            "title": "إبر إذابة الدهون في دبي",
            "subtitle": "تقليل الدهون غير الجراحي",
            "description": "هل تعاني من دهون عنيدة لا تختفي مهما اتبعت من أنظمة غذائية أو مارست التمارين الرياضية؟ تُعد إبر حرق الدهون هي الحل غير الجراحي لتقليل الدهون دون الحاجة إلى أنظمة غذائية صارمة أو تمارين بدنية شاقة. سواء كانت الدهون متركزة تحت الذقن، أو في البطن، أو في الفخذين أو غيرها من المناطق، يمكن لحقن حرق الدهون أن تُحدث فرقًا واضحًا في نحت الجسم وتحديد ملامحه. نفهم في ايليت بودي هوم هذه التحديات جيدًا، لذلك نقدم لكم علاج تقليل الدهون باستخدام تقنيات آمنة ومتطورة، تُجرى بأيدي متخصصين محترفين، لتحقيق قوام منحوت ومشدود بأقل فترة تعافٍ ممكنة."
        },
        "howItWorks": {
            "title": "كيف تعمل إبر إذابة الدهون؟",
            "description": "تهدف حقن التخسيس وحرق الدهون غير الجراحية إلى تفتيت الدهون الموضعية المتراكمة والتخلص منها عبر الجسم. تحتوي هذه الحقن عادةً على مواد فعالة تسرع من عملية تكسير الخلايا الدهنية وتدعم عملية نحت الجسم."
        },
        "procedureSteps": {
            "heading": "خطوات العلاج",
            "para": "إليك ما يمكن توقعه خلال جلسة إبر إذابة الدهون:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يبدأ الإجراء بجلسة استشارية، يتم خلالها إجراء فحص مكونات الجسم (BCA)، لتقييم الحالة الصحية بشكل شامل. وقد يُطلب إجراء فحوصات الدم في بعض الحالات.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "تحديد المنطقة",
                    "desc": "يتم تحديد الأماكن المستهدفة التي ستُحقن، وغالبًا ما تكون المناطق التي يظهر فيها تراكم الدهون بوضوح.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "عملية الحقن",
                    "desc": "تُحقن إبر إذابة الدهون باستخدام إبر دقيقة للغاية، ما يجعله إجراء مريح بأقل قدر من الألم. قد يستغرق ظهور النتائج بعض الوقت، لذلك قد يتطلب الأمر عدة جلسات لتحقيق النتائج المرغوبة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "يتم تقييم مدى تقدم الحالة ومقارنتها بالأهداف الموضوعة خلال زيارات المتابعة، مع إمكانية تعديل الخطة العلاجية عند الحاجة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد إبر إذابة الدهون",
            "subheading": "تقليل الدهون المستهدف بدون جراحة",
            "para": "تقدم إبر حرق الدهون العديد من المزايا لنحت الجسم:",
            "items": [
                {
                    "title": "إذابة الدهون العنيدة",
                    "desc": "تساعد على إذابة الدهون العنيدة المتراكمة في بعض المناطق.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "غير جراحي",
                    "desc": "تُعد حل غير جراحي يساعد على تحديد خط الفك وتحسين مظهر الذقن المزدوجة.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "بسيط وغير جراحي",
                    "desc": "تعتبر إجراء بسيط وغير جراحي.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "نتائج سريعة",
                    "desc": "تعمل على إذابة دهون البطن سريعًا.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "لا حاجة للتمارين",
                    "desc": "لا تتطلب مجهودًا بدنيًا شاقًا أو جلسات تمرين طويلة.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "تحقق نتائج طبيعية ناعمة.",
                    "icon": "fa-solid fa-leaf"
                }
            ]
        },
        "eligibility": {
            "heading": "المرشحون المثاليون",
            "subheading": "",
            "para": "تعتبر إبر حرق الدهون مثالية لكل من:",
            "items": [
                {
                    "title": "قريب من الوزن المثالي",
                    "desc": "الأشخاص الذين يتمتعون بوزن قريب من الوزن المثالي ولكن يمتلكون جيوب دهنية عنيدة.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "مناطق مستهدفة",
                    "desc": "الأشخاص الذين يريدون التخلص من الدهون في مناطق معينة مثل الذقن، والبطن، والفخذين.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "بديل غير جراحي",
                    "desc": "الأشخاص الذين يتمتعون بصحة جيدة ولا يرغبون في إجراءات جراحية.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "توقعات واقعية",
                    "desc": "الأشخاص الذين يمتلكون توقعات واقعية لنتائج تدريجية وطبيعية المظهر.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "بشرة مرطبة",
                    "desc": "الأشخاص الذين يتمتعون ببشرة مرطبة بشكل جيد مما يساعد على نحت الجسم بسهولة.",
                    "icon": "fa-solid fa-tint"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل العلاج",
            "subheading": "",
            "para": "للتحضير لجلسة إبر إذابة الدهون:",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "اشرب كميات كافية من الماء قبل الجلسة لدعم عملية التخلص من الدهون.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب مميعات الدم",
                    "desc": "تجنب الأدوية التي تزيد من سيولة الدم قبل الجلسة بعدة أيام.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "نظام غذائي صحي",
                    "desc": "حافظ على نظام غذائي متوازن لدعم عملية التخلص من السموم الطبيعية في الجسم.",
                    "icon": "fa-solid fa-apple-alt"
                },
                {
                    "title": "ملابس مريحة",
                    "desc": "اختر ملابس فضفاضة تسمح بالوصول السهل إلى مناطق العلاج.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "توفر إبر إذابة الدهون تحسينات تدريجية:",
            "items": [
                {
                    "title": "تحسن تدريجي",
                    "desc": "تظهر النتائج تدريجيًا على مدار عدة أسابيع بينما يعالج الجسم الدهون المذابة.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "جلسات متعددة",
                    "desc": "تحقيق النتائج المثالية يتطلب عادةً 3-6 جلسات بفاصل 4-6 أسابيع.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "تقليل دائم للدهون",
                    "desc": "تقلل بشكل دائم من عدد الخلايا الدهنية في المنطقة المعالجة.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "نحت طبيعي",
                    "desc": "تمنحك قوامًا منحوتًا وتعزز من ثقتك بنفسك.",
                    "icon": "fa-solid fa-user"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للحفاظ على نتائج إبر إذابة الدهون:",
            "items": [
                {
                    "title": "تدليك المنطقة المعالجة",
                    "desc": "التدليك اللطيف يمكن أن يساعد في توزيع المحلول وتحسين النتائج.",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "الحفاظ على النشاط",
                    "desc": "التمارين الخفيفة تساعد جسمك على استقلاب الدهون المحررة.",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "اشرب كميات كافية من الماء لدعم جهازك اللمفاوي.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "إكمال خطة العلاج",
                    "desc": "أكمل جميع الجلسات الموصى بها للحصول على أفضل النتائج.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل إبر حرق الدهون آمنة؟",
                    "answer": "نعم، تعتبر إبر حرق الدهون آمنة بشكل عام عند إجرائها من قبل متخصص مؤهل، مع ضمان التقنية الصحيحة والعناية اللاحقة لتقليل المخاطر."
                },
                {
                    "question": "كم تدوم نتائج إبر إذابة الدهون؟",
                    "answer": "نتائج إبر إذابة الدهون تدوم مدى الحياة. لا تعود الخلايا الدهنية إلى المناطق المعالجة."
                },
                {
                    "question": "ما هي أفضل إبرة لحرق الدهون؟",
                    "answer": "تعتمد أفضل إبرة لحرق الدهون على الاحتياجات الفردية، مع خيارات شائعة مثل أكواليكس وكيبيلا التي تستهدف مناطق الدهون العنيدة بشكل فعال."
                },
                {
                    "question": "هل إبر إذابة الدهون تعمل حقًا؟",
                    "answer": "نعم، تقوم إبر إذابة الدهون بتكسير الخلايا الدهنية، والتي يتم التخلص منها بعد ذلك بشكل طبيعي عن طريق الجسم."
                },
                {
                    "question": "كم عدد الجلسات التي سأحتاجها؟",
                    "answer": "معظم المرضى يحتاجون إلى 3-6 جلسات بفاصل 4-6 أسابيع للحصول على أفضل النتائج."
                }
            ]
        }
    }
}